import React from 'react';

import '../styles/image.css';

import Icon from '../components/Icon';

export default class ImageController extends React.Component {
  constructor(props) {
    super(props);
    this.image = React.createRef();
    this.submit = this.onSubmit.bind(this);
  }

  onSubmit(e) {
    const cb = this.props.onUpload;
    const data = new FormData();
    data.append('image', this.image.current.files[0]);
    fetch('/api/upload', {
      method: 'POST',
      body: data
    }).then((rsp) => {
      rsp.json().then((data) => {
        if (cb) {
          cb(data);
        }
      });
    });
    e.preventDefault();
  }

  render() {
    return <form className='image-form' onSubmit={this.submit}>
      <input id='image-upload' ref={this.image} type="file" />
      <label htmlFor='image-upload'>{this.props.children}</label>
      <button><Icon name='upload' /></button>
    </form>;
  }
}



// WEBPACK FOOTER //
// ./src/controllers/ImageController.js